import { useState } from "react";

import { Webhook } from "./types";

import useWebhooks from "./useWebhooks";
import WebhookAdd from "./WebhookAdd";
import WebhookDelete from "./WebhookDelete";
import WebhookTable from "./WebhookTable";
import WebhookEditDialog from "./WebhookEditDialog";

export default Webhooks;

type Webhooks = {
  eventName: string;
  createdAt: number;
  lastItemDate: number;
  webhookList: Array<Webhook>;
};

interface WebhooksProps {
  workspaceId: string;
  assistantId: string;
  webhooks: Webhooks;
  syncAssistant: (data: any | ((prev: any) => any)) => void;
  locked: boolean;
}

function Webhooks(props: WebhooksProps) {
  const { workspaceId, assistantId, webhooks, syncAssistant, locked } = props;

  const { addWebhook, removeWebhook, updateWebhook } = useWebhooks(
    workspaceId,
    assistantId,
    syncAssistant,
  );

  const [editWebhook, setEditWebhook] = useState<null | Webhook>(null);
  const [deleteWebhook, setDeleteWebhook] = useState<null | Webhook>(null);

  const { webhookList } = webhooks;

  return (
    <>
      <div className="flex flex-col gap-y-2 border rounded-lg m-4">
        <div className="px-6 py-4 bg-gray-50 rounded-t-lg w-full">
          <div className="flex items-center w-full justify-between">
            <p className="text-md font-semibold text-gray-900">Webhooks</p>
            {!locked && <WebhookAdd onWebhookAdd={addWebhook} />}
          </div>
          {/* <p className="text-sm text-gray-500">
                  Destination URLs for receiving post-conversation data
                </p> */}
        </div>
        <div className="min-h-96 px-4">
          <WebhookTable
            webhooks={webhookList}
            onWebhookDelete={(webhook: Webhook) => setDeleteWebhook(webhook)}
            onWebhookEdit={(webhook: Webhook) => setEditWebhook(webhook)}
            locked={locked}
          />
        </div>
      </div>
      {deleteWebhook && (
        <WebhookDelete
          webhook={deleteWebhook}
          onClose={() => setDeleteWebhook(null)}
          onWebhookDelete={removeWebhook}
        />
      )}
      {editWebhook && (
        <WebhookEditDialog
          webhook={editWebhook}
          onClose={() => setEditWebhook(null)}
          onEditWebhookSave={updateWebhook}
        />
      )}
    </>
  );
}
